import { Tenant } from "./tenant";

export class AssetRepresentation {
  name: string;
  description: string;
  icon: any[];
  tenant: Tenant;
  targetColor?: string;
}
